export default __webpack_public_path__ + "static/media/icon-loader.d8cc496d.png";